<template>
  <StandardCard
    :image="image"
    :name="image_title"
    :cols="12"
    >
    <template #info>
      <div class="UserHome-invitationcard-title" style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-right: 2px;
        margin-bottom: 5px;
        ">
        <p style="margin-bottom: 0px; padding: 3px;">
          <svg-icon
            v-if="icon && false"
            :name="icon"
          />
          <v-icon
            v-else-if="icon"
            >
            {{ icon }}
          </v-icon>
          {{ footer_left }}
        </p>
        <p style="margin-bottom: 0px; padding: 3px;">
          {{ footer_right }} </p>

    </div>
    </template>
  </StandardCard>
</template>

<script>

import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
export default {
  components: {
    StandardCard,
  },

  props: ['image', 'icon', 'footer_left', 'footer_right', 'image_title'],
}
</script>

<style>

</style>
